import React from 'react';

/**
 * Noor brand mark: an ivory serif "N" inside a navy badge with a gold border.
 * Flag and form removed by design — the mark must not resemble a government seal.
 *
 * - <NoorBadge/>  : the round badge mark only (use in header / favicon / small spots)
 * - <NoorLockup/> : badge + "NOOR PASSPORT SERVICES" wordmark + gold tagline
 *                   (use on dark/navy areas: footer, social, printed packet)
 */

const NAVY = '#16243F';
const GOLD = '#B08A2E';
const IVORY = '#F4ECD6';
export function NoorBadge({
  size = 36,
  className = '',
  title = 'Noor Passport Services'
}: {
  size?: number;
  className?: string;
  title?: string;
}) {
  return <svg width={size} height={size} viewBox="0 0 100 100" role="img" aria-label={title} className={className} data-id="element-249" data-mp="3ka5d7m0jri9d">
      <circle cx="50" cy="50" r="50" fill={NAVY} data-id="element-250" data-mp="2sk0udrsfr3a9" />
      {/* serif N: ivory fill with a gold outline so it plays with the border */}
      <text x="50" y="50" textAnchor="middle" dominantBaseline="central" fontFamily="Georgia, 'Times New Roman', serif" fontSize="66" fontWeight="700" fill={IVORY} stroke={GOLD} strokeWidth="2.4" strokeLinejoin="round" paintOrder="stroke" data-id="element-251" data-mp="2wkujuplj0q59">
        N
      </text>
    </svg>;
}
export function NoorLockup({
  className = '',
  badgeSize = 96
}: {
  className?: string;
  badgeSize?: number;
}) {
  return <div className={`flex flex-col items-center text-center ${className}`} data-id="element-252" data-mp="1q4ok5pyg548h">
      <NoorBadge size={badgeSize} data-id="element-253" data-mp="1m3mht098gc2a" />
      <p className="font-heading font-bold tracking-wide mt-4" style={{
      color: IVORY,
      fontSize: 'clamp(20px, 4vw, 30px)',
      letterSpacing: '0.06em'
    }} data-id="element-254" data-mp="1h632ry4pnv9a">
        NOOR PASSPORT SERVICES
      </p>
      <p className="italic mt-1" style={{
      color: GOLD,
      fontFamily: "Georgia, 'Times New Roman', serif",
      fontSize: 'clamp(14px, 2.4vw, 18px)'
    }} data-id="element-255" data-mp="3biszenmgrikd">
        We prepare. You submit. Simple.
      </p>
    </div>;
}